import { Link } from "react-router-dom";
import { useBrand } from "@/context/BrandContext";

// Uses brand.logoUrl / brand.logoUrlCream when set, otherwise a text wordmark.
// `tone="cream"` is for dark backgrounds (the footer).
export const Wordmark = ({ tone = "forest", size = "md", withDescriptor = false, testId = "brand-wordmark" }) => {
  const brand = useBrand();
  const onDark = tone === "cream";
  const colour = onDark ? "var(--brand-cream)" : "var(--brand-cocoa)";
  const logo = onDark ? brand.logoUrlCream || brand.logoUrl : brand.logoUrl;
  const logoHeights = {
    sm: "h-9",
    md: "h-10 sm:h-11",
    lg: "h-11 sm:h-12 xl:h-14",
  };
  const sizes = {
    sm: "text-base",
    md: "text-base lg:text-[17px] xl:text-xl",
    lg: "text-lg sm:text-xl xl:text-[22px]",
  };

  return (
    <Link
      to="/"
      data-testid={testId}
      aria-label={`${brand.name} — home`}
      className="group inline-flex shrink-0 items-center gap-2.5 sm:gap-3"
    >
      {logo ? (
        <img
          src={logo}
          alt={brand.name}
          data-testid="brand-logo-image"
          className={`w-auto ${logoHeights[size]} transition-transform duration-300 group-hover:-rotate-1`}
        />
      ) : (
        <>
          <span
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[20px] font-heading text-2xl font-black shadow-soft sm:h-[52px] sm:w-[52px]"
            style={{ background: "var(--brand-amber)", color: "var(--brand-forest)" }}
            aria-hidden="true"
          >
            M
          </span>
          <span
            className={`whitespace-nowrap font-heading font-black tracking-[-0.02em] ${sizes[size]}`}
            style={{ color: colour }}
          >
            {brand.name}
          </span>
        </>
      )}
      {withDescriptor && (
        <span
          className="hidden text-[11px] font-bold uppercase tracking-[0.16em] sm:inline"
          style={{ color: onDark ? "var(--brand-honey)" : "var(--brand-coral-ink)" }}
        >
          {brand.descriptor}
        </span>
      )}
    </Link>
  );
};

export default Wordmark;
